module.exports = __webpack_public_path__ + "static/img/airoad_contactbg.3ae9ec45.png";